import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

function loadView(view) {
  return () => import(`@/views/${view}`);
}

function loadAdminView(view) {
  return loadView(`admin/${view}`);
}

const routes = [
  { path: '/', name: 'home', component: loadView('Home.vue') },
  {
    path: '/intro',
    component: loadView('intro/Intro.vue'),
    children: [
      { path: 'team', name: 'introTeam', component: loadView('intro/IntroTeam.vue') },
      { path: 'gear', name: 'introGear', component: loadView('intro/IntroGear.vue') },
      { path: 'gallery', name: 'introGallery', component: loadView('intro/IntroGallery.vue') },
      { path: 'location', name: 'introLocation', component: loadView('intro/IntroLocation.vue') },
      { path: '', redirect: { name: 'introTeam' } },
    ],
  },
  { path: '/landing', name: 'landing', component: loadView('Landing.vue') },
  { path: '/privacy', name: 'privacy', component: loadView('Privacy.vue') },
  { path: '/counsel/model', name: 'counselModel', component: loadView('counsel/CounselModel.vue') },
  {
    path: '/media',
    component: loadView('media/Media.vue'),
    children: [
      { path: 'column', name: 'mediaColumnList', component: loadView('media/MediaColumnList.vue') },
      { path: 'column/:id', name: 'mediaColumnView', component: loadView('media/MediaColumnView.vue') },
      { path: 'case', name: 'mediaCaseList', component: loadView('media/MediaCaseList.vue') },
      { path: 'news', name: 'mediaNewsList', component: loadView('media/MediaNewsList.vue') },
      { path: 'news/:id', name: 'mediaNewsView', component: loadView('media/MediaNewsView.vue') },
      { path: 'visitor', name: 'mediaVisitorList', component: loadView('media/MediaVisitorList.vue') },
    ],
  },
  {
    path: '/event/:path',
    name: 'eventLanding',
    component: loadView('EventLanding.vue'),
  },
  {
    path: '/admin',
    component: loadAdminView('Admin.vue'),
    children: [
      {
        path: 'login', name: 'adminLogin', component: loadAdminView('AdminLogin.vue'), meta: { auth: false },
      },
      {
        path: 'privacy', name: 'privacyEdit', component: loadAdminView('AdminPrivacy.vue'), meta: { auth: true },
      },
      {
        path: 'main',
        name: 'adminMain',
        component: loadAdminView('main/AdminMain.vue'),
        meta: { auth: true },
        children: [
          { path: 'list', name: 'adminMainList', component: loadAdminView('main/AdminMainList.vue') },
          { path: 'write', name: 'adminMainWrite', component: loadAdminView('main/AdminMainWrite.vue') },
          { path: ':id/edit', name: 'adminMainEdit', component: loadAdminView('main/AdminMainWrite.vue') },
          { path: ':id', name: 'adminMainView', component: loadAdminView('main/AdminMainView.vue') },
        ],
      },
      {
        path: 'popup',
        name: 'adminPopup',
        component: loadAdminView('popup/AdminPopup.vue'),
        meta: { auth: true },
        children: [
          { path: 'list', name: 'adminPopupList', component: loadAdminView('popup/AdminPopupList.vue') },
          { path: 'write', name: 'adminPopupWrite', component: loadAdminView('popup/AdminPopupWrite.vue') },
          { path: ':id/edit', name: 'adminPopupEdit', component: loadAdminView('popup/AdminPopupWrite.vue') },
          { path: ':id', name: 'adminPopupView', component: loadAdminView('popup/AdminPopupView.vue') },
        ],
      },
      {
        path: 'column',
        name: 'adminColumn',
        component: loadAdminView('column/AdminColumn.vue'),
        meta: { auth: true },
        children: [
          { path: 'list', name: 'adminColumnList', component: loadAdminView('column/AdminColumnList.vue') },
          { path: 'write', name: 'adminColumnWrite', component: loadAdminView('column/AdminColumnWrite.vue') },
          { path: ':id/edit', name: 'adminColumnEdit', component: loadAdminView('column/AdminColumnWrite.vue') },
          { path: ':id', name: 'adminColumnView', component: loadAdminView('column/AdminColumnView.vue') },
        ],
      },
      {
        path: 'news',
        name: 'adminNews',
        component: loadAdminView('news/AdminNews.vue'),
        meta: { auth: true },
        children: [
          { path: 'list', name: 'adminNewsList', component: loadAdminView('news/AdminNewsList.vue') },
          { path: 'write', name: 'adminNewsWrite', component: loadAdminView('news/AdminNewsWrite.vue') },
          { path: ':id/edit', name: 'adminNewsEdit', component: loadAdminView('news/AdminNewsWrite.vue') },
          { path: ':id', name: 'adminNewsView', component: loadAdminView('news/AdminNewsView.vue') },
        ],
      },
      {
        path: 'case',
        name: 'adminCase',
        component: loadAdminView('case/AdminCase.vue'),
        meta: { auth: true },
        children: [
          { path: 'list', name: 'adminCaseList', component: loadAdminView('case/AdminCaseList.vue') },
          { path: 'write', name: 'adminCaseWrite', component: loadAdminView('case/AdminCaseWrite.vue') },
          { path: ':id/edit', name: 'adminCaseEdit', component: loadAdminView('case/AdminCaseWrite.vue') },
          { path: ':id', name: 'adminCaseView', component: loadAdminView('case/AdminCaseView.vue') },
        ],
      },
      {
        path: 'visitor',
        name: 'adminVisitor',
        component: loadAdminView('visitor/AdminVisitor.vue'),
        meta: { auth: true },
        children: [
          { path: 'list', name: 'adminVisitorList', component: loadAdminView('visitor/AdminVisitorList.vue') },
          { path: 'write', name: 'adminVisitorWrite', component: loadAdminView('visitor/AdminVisitorWrite.vue') },
          { path: ':id/edit', name: 'adminVisitorEdit', component: loadAdminView('visitor/AdminVisitorWrite.vue') },
          { path: ':id', name: 'adminVisitorView', component: loadAdminView('visitor/AdminVisitorView.vue') },
        ],
      },
      {
        path: 'counsel',
        namd: 'adminCounsel',
        component: loadAdminView('counsel/AdminCounsel.vue'),
        meta: { auth: true },
        children: [
          { path: 'list', name: 'adminCounselList', component: loadAdminView('counsel/AdminCounselList.vue') },
          { path: ':id', name: 'adminCounselView', component: loadAdminView('counsel/AdminCounselView.vue') },
        ],
      },
      {
        path: 'model',
        namd: 'adminModel',
        component: loadAdminView('model/AdminModel.vue'),
        meta: { auth: true },
        children: [
          { path: 'list', name: 'adminModelList', component: loadAdminView('model/AdminModelList.vue') },
          { path: ':id', name: 'adminModelView', component: loadAdminView('model/AdminModelView.vue') },
        ],
      },
      {
        path: 'event',
        name: 'adminEvent',
        component: loadAdminView('event/AdminEvent.vue'),
        meta: { auth: true },
        children: [
          { path: 'list', name: 'adminEventList', component: loadAdminView('event/AdminEventList.vue') },
          { path: 'write', name: 'adminEventWrite', component: loadAdminView('event/AdminEventWrite.vue') },
          { path: ':id/edit', name: 'adminEventEdit', component: loadAdminView('event/AdminEventWrite.vue') },
          { path: ':id', name: 'adminEventView', component: loadAdminView('event/AdminEventView.vue') },
        ],
      },
      {
        path: 'contact', name: 'adminContact', component: loadAdminView('user/AdminContact.vue'), meta: { auth: true },
      },
      {
        path: 'password', name: 'adminUser', component: loadAdminView('user/AdminUser.vue'), meta: { auth: true },
      },
      { path: '', redirect: { name: 'adminMainList' } },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
});

router.beforeEach(async (to, from, next) => {
  console.log(to.path, to.matched.some((t) => t.meta.auth), !!store.getters.token);
  const auth = to.matched.some((t) => t.meta.auth);

  if (auth && !store.getters.token) {
    return next({ name: 'adminLogin' });
  }

  if (auth && !store.getters.user) {
    await store.dispatch('me');

    if (!store.getters.user) {
      return next({ name: 'adminLogin' });
    }
  }

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);
  // eslint-disable-next-line no-unused-vars
  const previousNearestWithMeta = from.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map((tagDef) => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach((key) => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));
  return next();
});

export default router;
